import {msToHours} from '../Common/Util_methods/format'

class FormatMachineStates{
    static failureDuration(machineStateData){
        let arr = []
        machineStateData.map((obj)=>{
            const d = new Date(obj.date)
            //
            const monthName = d.toLocaleString("default",{month:"long"})
            arr.push({text:monthName, failureDuration:msToHours(obj.failureDuration)})
        })
        return arr
    }
    static runningDuration(machineStateData){
        let arr = []
        machineStateData.map((obj)=>{
            const d = new Date(obj.date)
            //
            const monthName = d.toLocaleString("default",{month:"long"})
            arr.push({text:monthName, runningDuration:obj.runningDuration})
        })
        return arr
    }
    static idleDuration(machineStateData){
        let arr = []
        machineStateData.map((obj)=>{
            const d = new Date(obj.date)
            //
            const monthName = d.toLocaleString("default",{month:"long"})
            arr.push({text:monthName, idleDuration:obj.idleDuration})
        })
        return arr
    }
    static durationsToHours(machineStateData){
        let arr = []
        machineStateData.forEach((obj)=>{
            let newObj = {...obj};
            newObj.failureDuration = msToHours(obj.failureDuration)
            newObj.idleAfterRunningDuration = msToHours(obj.idleAfterRunningDuration)
            newObj.idleAfterFailureDuration = msToHours(obj.idleAfterFailureDuration)
            newObj.shiftDuration = msToHours(obj.shiftDuration)
            newObj.failureTimeoutDuration = msToHours(obj.failureTimeoutDuration)
            newObj.runningDuration = msToHours(obj.runningDuration)
            newObj.failureDurationPerDay = msToHours(obj.failureDurationPerDay)
            newObj.idleAfterRunningDurationPerDay = msToHours(obj.idleAfterRunningDurationPerDay)
            newObj.idleAfterFailureDurationPerDay = msToHours(obj.idleAfterFailureDurationPerDay)
            newObj.shiftDurationPerDay = msToHours(obj.shiftDurationPerDay)
            newObj.failureTimeoutDurationPerDay = msToHours(obj.failureTimeoutDurationPerDay)
            newObj.runningDurationPerDay = msToHours(obj.runningDurationPerDay)
            arr.push(newObj);
        })
        //
        return arr;
    }
}
export default FormatMachineStates;